var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62954 0.785156H1.97748C1.32055 0.785156 0.786133 1.31958 0.786133 1.97651V5.62857C0.786133 6.2855 1.32055 6.81992 1.97748 6.81992H5.62954C6.28647 6.81992 6.82089 6.2855 6.82089 5.62857V1.97651C6.82089 1.31958 6.28647 0.785156 5.62954 0.785156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62954 8.74023H1.97748C1.32055 8.74023 0.786133 9.27465 0.786133 9.93158V13.5836C0.786133 14.2406 1.32055 14.775 1.97748 14.775H5.62954C6.28647 14.775 6.82089 14.2406 6.82089 13.5836V9.93158C6.82089 9.27465 6.28647 8.74023 5.62954 8.74023Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7932 3.52692H9.01541C8.71244 3.52692 8.4668 3.28127 8.4668 2.9783C8.4668 2.67533 8.71244 2.42969 9.01541 2.42969H17.7932C18.0962 2.42969 18.3419 2.67533 18.3419 2.9783C18.3419 3.28127 18.0962 3.52692 17.7932 3.52692Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7759 5.58551H9.01541C8.71244 5.58551 8.4668 5.33987 8.4668 5.0369C8.4668 4.73392 8.71244 4.48828 9.01541 4.48828H14.7759C15.0788 4.48828 15.3245 4.73392 15.3245 5.0369C15.3245 5.33987 15.0788 5.58551 14.7759 5.58551Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7932 11.3472H9.01541C8.71244 11.3472 8.4668 11.1016 8.4668 10.7986C8.4668 10.4956 8.71244 10.25 9.01541 10.25H17.7932C18.0962 10.25 18.3419 10.4956 18.3419 10.7986C18.3419 11.1016 18.0962 11.3472 17.7932 11.3472Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7759 13.5405H9.01541C8.71244 13.5405 8.4668 13.2948 8.4668 12.9919C8.4668 12.6889 8.71244 12.4432 9.01541 12.4432H14.7759C15.0788 12.4432 15.3245 12.6889 15.3245 12.9919C15.3245 13.2948 15.0788 13.5405 14.7759 13.5405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseHistory);
export default __webpack_public_path__ + "static/media/purchase-history.e848e3de085283f8b82372358413c885.svg";
export { ForwardRef as ReactComponent };